<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../../app.logic";
  import Input from "../../../components/Form/Fields/Input.svelte";
  import FormField from "../../../components/Form/FormField.svelte";
  import FormLayout from "../../../layout/FormLayout.svelte";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import type { IApiResponse } from "../../../utils/api/api-response";
  import { initDetail, onPrint, record, save } from "./quality-incident.store";
  import Textarea from "../../../components/Form/Fields/Textarea.svelte";
  import ClfDropdown from "../../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import DateInputString from "../../../components/Form/Fields/DateInputString.svelte";
  import Switch from "../../../components/Form/Fields/Switch.svelte";
  import type { IQualityIncident } from "../../../entities/quality-incident";
  import Button from "../../../components/Button.svelte";
  import Label from "../../../components/Form/Label.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.documentDate != "" && !!$record.clfProcedureId && $record.sender != "" && $record.estimatedCompletionDate != "";
  $: canEdit = $record != null && $record.oid == 0;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IQualityIncident> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/quality-incident/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/quality-incident`);
  }

  function docNumber(doc: IQualityIncident) {
    if (!doc || doc.oid == 0) return "da assegnare";
    return doc.yearlyNumber + " / " + doc.year;
  }

  onMount(() => initDetail(oid));
</script>

<QualityLayout>
  {#if $record}
    <div class="columns" style="margin-top:1rem;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            {#key $record}
              <div class="column is-2">
                <FormField>
                  <Input name="Numero" placeholder="" disabled={true} required={false} value={docNumber($record)} />
                </FormField>
              </div>
              <div class="column is-2">
                <FormField>
                  <DateInputString name="Data" placeholder="" required={true} disabled={!canEdit} bind:value={$record.documentDate} />
                </FormField>
              </div>
            {/key}
            <div class="column is-3">
              <FormField>
                <ClfDropdown name="Origine" placeholder="" schema="QLINCITRSN" required={true} bind:value={$record.clfProcedureId} />
              </FormField>
            </div>
            <div class="column is-3">
              <FormField>
                <Input name="Rilevato da" placeholder="" required={true} bind:value={$record.sender} />
              </FormField>
            </div>
            <div class="column is-1">
              <FormField klass="has-text-right">
                <Switch name="Chiuso" bind:value={$record.closed} />
              </FormField>
            </div>
            <div class="column is-1">
              <FormField klass="has-text-right">
                <Label>&nbsp;</Label>
                <Button klass="is-warning" disabled={isNew} on:click={onPrint}>Stampa</Button>
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Textarea name="Descrizione della non conformità" placeholder="" required={false} bind:value={$record.description} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Textarea name="Analisi delle cause" placeholder="" required={false} bind:value={$record.causes} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Textarea name="Trattamento non conformità – intervento da effettuare" placeholder="" required={false} bind:value={$record.correction} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <FormField>
                <DateInputString name="Data prevista per il completamento" placeholder="" required={true} bind:value={$record.estimatedCompletionDate} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField>
                <DateInputString name="Data effettiva di chiusura" placeholder="" bind:value={$record.actualCompletionDate} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField klass="has-text-right">
                <Switch name="Esito positivo" bind:value={$record.outcome} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</QualityLayout>
